<template>
  <div id="newChangePurchaseOrder">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
      </el-col>
       <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 17%;">
      <p class="headerT" >采购订单变更信息</p>
      <el-form ref="purchaseOrderForm" :model="purchaseOrderForm" label-width="120px" :label-position="labelPosition" :rules="purchaseOrderFormRules">
        <el-form-item label="订单编号" prop="code">
          <el-select v-model="purchaseOrderForm.code" filterable  placeholder="订单编号" style="width: 100%;" clearable @change="getCode">
            <el-option v-for="(item,index) in codeList" 
              :label="item.code" 
              :value="item.id" 
              :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注信息"  prop="memo">
          <el-input v-model.trim="purchaseOrderForm.memo"></el-input>
        </el-form-item>
        
      </el-form>
      <p class="headerT" >变更内容</p>
      <el-form ref="purchaseOrderForm" :model="purchaseOrderForm" label-width="120px" :label-position="labelPosition" :rules="purchaseOrderFormRules">
        <el-form-item label="供应商"  prop="supplierName">
          <el-select v-model="purchaseOrderForm.supplierName" placeholder="请选择供应商" style="width: 100%;" clearable @change="getSupplier">
            <el-option v-for="(item,index) in supplierList" 
              :label="item.supplierName" 
              :value="item.id" 
              :key="item.supplierCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购日期"  prop="purchaseTime">
          <el-date-picker style="width: 100%;"
            v-model="purchaseOrderForm.purchaseTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="预期交货日期" prop="aogTime">
          <el-date-picker style="width: 100%;"
            v-model="purchaseOrderForm.aogTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 80%;">
      <!-- <p class="headerT">供应商信息详情</p> -->
      <p class="headerT fl">订单详情</p>
      <el-button  size="small"  type="success" class="fr" @click="newMater()">新建明细</el-button>
      <el-card class="box-card fr" style="width: 100%;">
        <el-table
          :data="returnData"
          border
          :header-cell-style="{'text-align':'center'}"
          style="width: 100%"
          :summary-method="getSummaries"
          show-summary>
          <el-table-column
            align="center"
            type="index"
            width="50"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
            width="50">
            <template slot-scope="scope">
              <el-button @click.stop="deleteRow(scope.$index, returnData)" type="text" size="small">移除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCoding"
            label="物料编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="number"
            label="采购数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            :formatter="addCommas"
            label="采购单价(元)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="amount"
            :formatter="addCommas"
            label="合计金额">
          </el-table-column>
        </el-table>
      </el-card>
      <el-col :span="24" class="toolbar">
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next"
            :total="pages.total">
          </el-pagination>
        </div>
      </el-col>
      <el-dialog title="新建物料信息" :visible.sync="dislogMater" :close-on-click-modal="false" width="600px"  @close="emptyDialog('materForm')">
        <el-form ref="materForm" :model="materForm" label-width="100px" :label-position="labelPosition" 
        :rules="materFormRules">
          <el-form-item label="物料编号：" prop="materialCoding">
            <!--<el-input v-model="materForm.materialCoding"></el-input>-->
            <el-select v-model="materForm.materialCoding" placeholder="请选择物料编号" style="width: 100%;"
                       @change="changeMethods">
              <el-option v-for="(item,index) in materNumberList" :label="item.materialCoding" :value="item.materialCoding" :key="index" clearable ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物料名称：" prop="materialName">
            <el-input v-model.trim="materForm.materialName"></el-input>
          </el-form-item>
          <el-form-item label="采购数量：" prop="number">
            <template>
              <el-input-number v-model.trim="materForm.number" :min="1" ></el-input-number>
            </template>
          </el-form-item>
          <el-form-item label="采购单价：" prop="price">
            <el-input v-model.trim="materForm.price" @blur="toThousands(materForm.price)"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addEventFormSubmitBtn('materForm')">添加</el-button>
          <el-button @click="emptyDialog('materForm')">取 消</el-button>
        </span>
      </el-dialog>
      <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 0;">
        提交为
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="DetermineSave()">已确认</el-dropdown-item>
          <el-dropdown-item @click.native="temporarySave()">暂存</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
        {{pageStatus}}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item>
          <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消暂存变更单</el-button> 
    </el-col>
    
  </div>
</template>

<script>
  let moment = require("moment");

 import {
    supplierList,getMaterialList,getpurchasingChangeInfo,delpurchasingChangeInfo,purchasingChangeEdit
  } from "../../api/api";
 import {getPermission} from '../../api/authRequest'

 export default {
    name: 'newChangePurchaseOrder',
    components: {
    },
    data () {
      return {
        pageStatus:'留在当前页面',
        dialogVisible:false,
        saveStatus:'YQR',
        materialCoding:'',
        codeList:[],
        materNumberList:[],
        dislogMater:false,
        supplierList:[],
        labelPosition:'left',
        purchaseOrderForm:{
          code: '',
          codeOldId: '',
          memo: '',
          supplier: '',
          supplierName:'',
          paymentTime: '',
          purchaseTime: '',
          aogTime: '',
        },
        purchaseOrderFormRules:{//validateRoleName
          code: [{ required: true, message: "请选择订单编号", trigger: "blur" }],
          supplierName: [{ required: true, message: "请输入供应商名称", trigger: "blur" }],
          aogTime: [{ required: true, message: "请输入预期交货日期", trigger: "blur" }],
          purchaseTime: [{ required: true, message: "请输入采购日期", trigger: "blur" }],
        },
        returnData: [],
        materForm:{
          materialCoding:'',
          materialName:'',
          number: '',
          amount:'',
          price:'',
          backUpPrice:'',
        },
        materFormRules:{
          materialCoding: [{ required: true, message: "请选择物料编号", trigger: "submit" }],
          materialName: [{ required: true, message: "请输入物料名称", trigger: "submit" }],
          price: [{ required: true, message: "请输入采购单价", trigger: "submit" }],
        },
        sum:'',
        amout: '',
        //分页变量
        pages:{
          total: 0,
          page: 1,
          pageSize: 10,
        },
      }
    },
    created:function(){
        this.$destroy();
    },
    mounted () {
      if (!this.$route.query.orderId) {
        var userOrderId = sessionStorage.getItem('saveOrderId');
        this.orderId = JSON.parse(userOrderId);
      }else{
        let orderId = this.$route.query.orderId
        this.orderId = orderId
      }
      this.getsupplierLists();
      this.getPurchasingChangeInfo()


    },
    methods: {
      //获取订单详情
      getPurchasingChangeInfo() {
        let para={
          id: this.orderId,
          startRow: this.pages.page,
          pageSize: this.pages.pageSize
        }
        getpurchasingChangeInfo(para).then(res => {          
          if (res.data.status==100) {            
            this.returnData = res.data.results.purchasingChangeDetails.list
            this.returnData.forEach((item) =>{
              return item.amount = item.price*item.number
            })
            this.purchaseOrderForm = res.data.results.purchasingChangeInfo
            this.purchaseOrderForm.codeOldId = res.data.results.purchasingChangeInfo.id
            this.purchaseOrderForm.purchaseTime = moment(res.data.results.purchasingChangeInfo.purchaseTime).format("YYYY-MM-DD");
            this.purchaseOrderForm.aogTime = moment(res.data.results.purchasingChangeInfo.aogTime).format("YYYY-MM-DD");

            let _sum = 0;
            this.returnData.forEach((item) => {
               //遍历number这个字段，并累加
               _sum += item.number;
             });
            this.sum = _sum
            let _amout = 0;
            this.returnData.forEach((item) => {
               //遍历amount这个字段，并累加
               _amout += item.number*item.price;
             });
            this.amout = _amout
            sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.purchasingChangeInfo.id));
            this.pages.pageSize = res.data.results.purchasingChangeDetails.pageSize
            this.pages.page = res.data.results.purchasingChangeDetails.startRow
            this.pages.total = res.data.results.purchasingChangeDetails.total
            
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //获取供应商下拉列表
      getsupplierLists() {
        supplierList().then(res => {
          if (res.data.status==100) {
            this.supplierList = res.data.results
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //获取采购订单列表 getPurchasingChanges
      getPurchasingChangesLists() {
        getPurchasingChanges().then(res => {
          if (res.data.status==100) {
            this.codeList = res.data.results
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      
      getCode(e){
        this.getPurchaseOrdersInfo(e)
      },
      getSupplier(e){
        for (var orderId in this.supplierList) {
          if (e === this.supplierList[orderId].id) {
            this.purchaseOrderForm.supplier = this.supplierList[orderId].id
            this.purchaseOrderForm.supplierName = this.supplierList[orderId].supplierName
            this.purchaseOrderForm.paymentTime = this.supplierList[orderId].allottedTime
          }
        }
      },
      toThousands(num) {
        this.materForm.backUpPrice = num
        num = num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        this.materForm.price = (((sign)?'':'-') + num + '.' + cents)
        return (((sign)?'':'-') + num + '.' + cents);
      },
      addCommas:function(row,column){
        var num = row[column.property];
        var b= num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      toThousands2(num) {
        // this.materForm.backUpPrice = num
        num = num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        // this.materForm.price = (((sign)?'':'-') + num + '.' + cents)
        return (((sign)?'':'-') + num + '.' + cents);
      },
      //已提交
      DetermineSave(){
        this.saveStatus = 'YQR';
        // console.log(this.purchaseOrderForm)
        if (this.purchaseOrderForm.code==""||this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime==""||this.purchaseOrderForm.purchaseTime==""||this.purchaseOrderForm.aogTime==""||this.returnData=="") {
          this.$message({
            message: '带*选项为必填信息,请补全产品信息，再提交！',
            type: 'warning'
          });
          
        }else{
          let para={
            id:this.purchaseOrderForm.id,
            pIdOld:this.purchaseOrderForm.pIdOld,
            supplier: this.purchaseOrderForm.supplier,
            supplierName: this.purchaseOrderForm.supplierName,
            paymentTime: this.purchaseOrderForm.paymentTime,
            purchaseTime: this.purchaseOrderForm.purchaseTime,
            aogTime: this.purchaseOrderForm.aogTime,
            memo:this.purchaseOrderForm.memo,
            status: this.saveStatus,
            amout: this.amout,
            sum: this.sum,
            purchasingChangeDetails: this.returnData,
          }
          // console.log(para)
          purchasingChangeEdit(para).then(res => {
            if (res.data.status==100) {
              if (this.pageStatus == '留在当前页面') {
                this.dialogVisible = false
                this.purchaseOrderForm = {}
                this.returnData = []
              }else{
                // parent.location.reload();
                this.tabRemove(this.$route.path)
                this.$router.replace({
                  path:'/purchaseOrderChangeManage'
                })
              }
            }else{
              this.$message({
                message: res.data.message,
                type: "error"
              });
            }
          }).catch((error) =>{
            this.$Message.error(error.message);
          })
        }
      },
      //暂存
      temporarySave(){
        this.saveStatus = 'CG';
        if (this.purchaseOrderForm.supplier==""||this.purchaseOrderForm.supplierName==""||this.purchaseOrderForm.paymentTime==""||this.purchaseOrderForm.purchaseTime==""||this.purchaseOrderForm.aogTime==""||this.returnData=="") {
          this.$message({
            message: '请补全产品信息，再提交！',
            type: 'warning'
          });
          
        }else{
          let para={
            id:this.purchaseOrderForm.id,
            pIdOld:this.purchaseOrderForm.pIdOld,
            supplier: this.purchaseOrderForm.supplier,
            supplierName: this.purchaseOrderForm.supplierName,
            paymentTime: this.purchaseOrderForm.paymentTime,
            purchaseTime: this.purchaseOrderForm.purchaseTime,
            aogTime: this.purchaseOrderForm.aogTime,
            memo:this.purchaseOrderForm.memo,
            status: this.saveStatus,
            amout: this.amout,
            sum: this.sum,
            purchasingChangeDetails: this.returnData,
        }
        // console.log(para)
        purchasingChangeEdit(para).then(res => {
          if (res.data.status==100) {
            if (this.pageStatus == '留在当前页面') {
              this.dialogVisible = false
              this.purchaseOrderForm = {}
              this.returnData = []
            }else{
              // parent.location.reload();
              this.tabRemove(this.$route.path)
              this.$router.replace({
                path:'/purchaseOrderChangeManage'
              })
            }
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        }
        
      },
      closeSave(){
        this.pageStatus = "离开当前页面"
      },
      goOnSave(){
        this.pageStatus = "留在当前页面"
      },
      //取消新建
      cancelOrder(){
        let para={
          id:this.purchaseOrderForm.id,
        }
        delpurchasingChangeInfo(para).then(res => {
          if (res.data.status==100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.tabRemove(this.$route.path)
            this.$router.replace({
              path:'/purchaseOrderChangeManage'
            })
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        
      },
      tabRemove (targetName) {
          // 首页不可删除
          if(targetName == '/') {
            return;
          }
          //将该tab从options里移除
          this.$store.commit('delete_tabs', targetName);
          ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
          if (this.activeIndex === targetName) {
            // 设置当前激活的路由
            if (this.options && this.options.length >= 1) {
              this.$store.commit('set_active_index', this.options[this.options.length-1].route);
              this.$router.push({path: this.activeIndex});
            } else {
              this.$router.push({path: '/welcome'});
            }
          }
      },
      changeMethods(name) {
        for (var i in this.materNumberList) {
          if (name ===this.materNumberList[i].materialCoding) {
            this.materForm.materialName = this.materNumberList[i].materialName
          }
        }
      },
      handleSizeChange(val) {
        this.pages.pageSize = val
        this.getPurchasingChangeInfo()
      },
      handleCurrentChange(Page) {
        this.pages.page = Page
        this.getPurchasingChangeInfo()
      },
      //获取物料编号
      getMaterNumberList(){
        getMaterialList().then(res => {
          if (res.data.status==100) {
            this.materNumberList = res.data.results
            // console.log(this.materNumberList)

          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      addEventFormSubmitBtn(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.returnData.push(
              { materialCoding: this.materForm.materialCoding,
                materialName: this.materForm.materialName,
                number:this.materForm.number,
                price:this.materForm.backUpPrice,
                amount:this.materForm.number*this.materForm.backUpPrice
              }
            )
            let _sum = 0;
            this.returnData.forEach((item) => {
               //遍历number这个字段，并累加
               _sum += item.number;
             });
            this.sum = _sum
            let _amout = 0;
            this.returnData.forEach((item) => {
               //遍历amount这个字段，并累加
               _amout += item.amount;
             });
            this.amout = _amout
            this.$refs[formName].resetFields();
            this.dislogMater = false
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //清空dialogvalue
      emptyDialog(formName) {
        this.$refs[formName].resetFields();
        this.dislogMater = false
      },
      newMater(){
        this.dislogMater = true
        this.getMaterNumberList()
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 5) {
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = '';
          }
        });
        if (sums[6] > 0) {
          sums[6] = this.toThousands2(sums[6]);
        }
        return sums;
      },
      //移除订单
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      //切换订单详情与订单事件
     changeState(item,index) {
      this.activeBtnIndex = index
     },
      //复制内容
      handleCopy(text, event) {
         clip(text, event)
      },
      //返回上一页
      backGo() {
        this.$router.push({
          path:'/purchaseOrderChangeManage'
        })
      },
      refresh() {
        this.getPurchasingChangesLists()
        
      },
    },
    computed: {
    },
    watch: {
      
    }
  }
</script>

<style type="text/css" lang="scss" scoped>
  #newChangePurchaseOrder{
    font-size: 14px;
    /*tr.el-table__row{cursor: pointer;}*/
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    /*.el-step__icon{width: 10px;height: 10px;}*/
    .el-step__icon.is-text{border-color: #1abc9c;}
    .toolbar{margin: 20px 0;}
  }
  
</style>



// WEBPACK FOOTER //
// newChangePurchaseOrderChangeOrder.vue?4bdd94b0